import React from 'react';
import { observer } from 'mobx-react';
import { localStorageHandler } from 'core/services';
import { action, observe, observable, isObservable, toJS, runInAction, makeObservable } from 'mobx';
import { FormBase } from 'core/components';
import { ConfirmModalParams } from 'core/models';
import { translate, isSome } from 'core/utils';
import ReactDOM from 'react-dom';
import validatorjs from 'validatorjs';
import moment from 'moment';
import _ from 'lodash';

class TableFilterForm extends FormBase {
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'minValue',
			(inputValue, args, attribute) => {
				let minimumValue = TableFilterForm.$('numberRangeStart').value;
				if (parseFloat(inputValue) < parseFloat(minimumValue) || parseFloat(inputValue) === parseFloat(minimumValue)) {
					return false;
				}
				return true;
			},
			'FILTER.NUMERIC.MINVALUE'
		);

		return {
			fields: [
				'freeType',
				'search',
				'searchList[]',
				'selectedList[]',
				'specificDate',
				'dateRangeStart',
				'dateRangeEnd',
				'specificNumber',
				'numberRangeStart',
				'numberRangeEnd',
				'filterErrorOrders',
				'selectAll',
			],
			labels: {
				freeType: 'FILTER.FREETYPE.LABEL',
				search: 'FILTER.SEARCH',
				specificDate: 'FILTER.DATE',
				dateRangeStart: 'FILTER.DATESTART',
				dateRangeEnd: 'FILTER.DATEEND',
				specificNumber: 'FILTER.NUMBER',
				numberRangeStart: 'FILTER.NUMBERSTART',
				numberRangeEnd: 'FILTER.NUMBEREND',
				filterErrorOrders: 'FILTER.HASERRORS',
			},
			placeholders: {
				freeType: 'FILTER.FREETYPE.PLACEHOLDER',
			},
			rules: {
				specificNumber: 'numeric|numericMinValue|invalidCharacter',
				numberRangeStart: 'numeric|numericMinValue|invalidCharacter',
				numberRangeEnd: 'numeric|numericMinValue|invalidCharacter',
			},
		};
	}
}

class TableFilter extends React.Component {
	@observable loading = true;
	@observable errorMessage = null;
	@observable focusContainsField = true;
	@observable isSelectAll;
	scrollContainerRef = React.createRef();
	isFoListFilter = false;
	columnTitle = null;
	format = null;

	warningModal = new ConfirmModalParams({
		onConfirm: () => {
			this.tableFilter.visible = false;
		},
	});

	constructor(props) {
		super(props);
		makeObservable(this);
		this.tableFilter = props.viewStore ? props.viewStore.tableFilter : { visible: false };
		this.columnFilterSetup = props.columnFilterSetup;
		this.selected = {};
		this.form = new TableFilterForm();
		this.form.observe({
			path: 'search',
			key: 'value',
			call: _.debounce(this.onSearch, 500, { maxWait: 1000 }),
		});
		let locale = window.navigator.userLanguage || window.navigator.language;
		moment.locale(locale);
		// Get locale data
		let localeData = moment.localeData();
		this.format = localeData.longDateFormat('L');
		isObservable(this.tableFilter) &&
			observe(this.tableFilter, 'visible', async change => {
				if (change.newValue === true) {
					this.prevFilter = toJS(this.tableFilter.column.filter);
					if (this.prevFilter) {
						this.selected[this.tableFilter.column.title] = [];
						if (
							this.tableFilter.column.filter &&
							(this.tableFilter.column.filter.selected && this.tableFilter.column.filter.selected.length)
						) {
							this.selected[this.tableFilter.column.title] = _.sortBy(this.tableFilter.column.filter.selected.slice());
							this.form.$('selectedList').set('value', this.selected[this.tableFilter.column.title]);
							this.form.$('freeType').set('value', this.tableFilter.column.filter.freeType);
						} else {
							this.selected[this.tableFilter.column.title] = [];
							this.form.$('selectedList').set('value', this.selected[this.tableFilter.column.title]);
							this.form.$('freeType').set('value', this.tableFilter.column.filter.freeType);
						}
						if (
							this.tableFilter.column.filter &&
							((this.tableFilter.column.filter.dateRangeStart && this.tableFilter.column.filter.dateRangeEnd) ||
								this.tableFilter.column.filter.specificDate)
						) {
							this.form
								.$('specificDate')
								.set(
									'value',
									moment(this.tableFilter.column.filter.specificDate).isValid()
										? moment(this.tableFilter.column.filter.specificDate).format(this.format)
										: ''
								);
							this.form
								.$('dateRangeStart')
								.set(
									'value',
									moment(this.tableFilter.column.filter.dateRangeStart).isValid()
										? moment(this.tableFilter.column.filter.dateRangeStart).format(this.format)
										: ''
								);
							this.form
								.$('dateRangeEnd')
								.set(
									'value',
									moment(this.tableFilter.column.filter.dateRangeEnd).isValid()
										? moment(this.tableFilter.column.filter.dateRangeEnd).format(this.format)
										: ''
								);
						}
						if (
							this.tableFilter.column.filter &&
							(this.tableFilter.column.filter.numberRangeStart ||
								this.tableFilter.column.filter.numberRangeEnd ||
								this.tableFilter.column.filter.specificNumber ||
								this.tableFilter.column.filter.hasErrors)
						) {
							this.form.$('specificNumber').set('value', this.tableFilter.column.filter.specificNumber);
							this.form.$('numberRangeStart').set('value', this.tableFilter.column.filter.numberRangeStart);
							this.form.$('numberRangeEnd').set('value', this.tableFilter.column.filter.numberRangeEnd);
							this.form.$('filterErrorOrders').value = this.tableFilter.column.filter.hasErrors;
						}
					} else {
						this.form.clear();
						this.checkDatesOnDateChange();
					}
					await this.onSearch({
						form: this.form,
						change: { newValue: '' },
					});
				}
			});
	}

	TableFilterKeyDown = evt => {
		if (evt.keyCode == 27) {
			this.onClose();
		}
		if (evt.keyCode == 13 && this.form.$('freeType').value != '') {
			this.onApply();
		}
	};

	TableFilterClickedOutside = evt => {
		if (ReactDOM.findDOMNode(this)) {
			if (!ReactDOM.findDOMNode(this).contains(evt.target)) {
				this.onClose();
			}
		}
	};

	handleScrollEvent = evt => {
		if (this.tableFilter.visible) {
			this.tableFilter.calculatePopupPosition();
		}
	};

	componentWillMount() {
		window.addEventListener('keydown', this.TableFilterKeyDown);
		window.addEventListener('mousedown', this.TableFilterClickedOutside);
		window.addEventListener('scroll', this.handleScrollEvent, true);
	}

	componentDidUpdate() {
		runInAction(() => {
			this.focusContainsField = false;
		}); // Leave autofocus on selected field on every component update.
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.TableFilterKeyDown);
		window.removeEventListener('mousedown', this.TableFilterClickedOutside);
		window.removeEventListener('scroll', this.handleScrollEvent);
	}

	@action.bound onClose() {
		this.errorMessage = null;
		this.tableFilter.visible = false;
	}

	@action.bound async onClear() {
		this.form.reset();
		this.selected[this.tableFilter.column.title] = [];
		this.checkDatesOnDateChange();
		await this.onSearch({ form: this.form, change: { newValue: '' } });
	}

	@action.bound
	onSearch = async props => {
		this.loading = true;
		this.focusContainsField = true; // On filter open, autofocus 'contains' field
		const { column, services } = this.tableFilter;
		const { form, change } = props;
		column.page = 1;
		column.rpp = 100;

		if (this.shouldSkipSearch(column)) {
			// Date or numeric range, no need to search anything
			this.loading = false;
			if (column.isFoListFilter) {
				this.isFoListFilter = true;
			} else {
				this.isFoListFilter = false;
			}
			return;
		}
		if (
			column.dataCell != null &&
			(column.dataCell.name === 'BooleanCellData' || column.dataCell.name === 'BuyerRequestedCancelCellData')
		) {
			form.$('searchList').set('value', [translate(['YES']), translate(['NO'])]);
			if (this.selected[column.title] === undefined) {
				this.selected[column.title] = [];
			}
			this.loading = false;
			this.isFoListFilter = false;
			return;
		}
		let searchValue = change.newValue ? `${change.newValue}` : '';
		let seller = localStorageHandler.get('selectedSeller');
		let data = [];
		if (column.getDistinctValues && isSome(column.service)) {
			const serviceIdx = this.getServiceIndex(services, column);
			if (serviceIdx !== -1) {
				data = (await services[serviceIdx].getDistinctValues({
					fieldName: column.key,
					pageNumber: column.page,
					search: searchValue,
				})).data;
			}
		} else {
			data = await this.tableFilter.find(searchValue, seller != null ? seller.value : null);
		}
		data = _.reduce(
			data,
			(acc, dataItem) => {
				if (!_.find(this.selected[column.title], selectedItem => selectedItem === dataItem)) {
					acc.push(dataItem);
				}
				return acc;
			},
			[]
		);
		if (this.selected[column.title] === undefined) {
			this.selected[column.title] = [];
		}
		data = this.selected[column.title].concat(data);
		form.$('searchList').set('value', data);
		this.loading = false;
		return true;
	};

	shouldSkipSearch = column => {
		return (
			column.filterType.displayName === 'TableFilterDateTemplate' ||
			column.filterType.displayName === 'TableFilterNumericTemplate'
		);
	};

	getServiceIndex = (services, column) => {
		return _.findIndex(services, service => {
			return service.constructor.name.toLowerCase() == column.service.toLowerCase();
		});
	};

	@action.bound onSelect(props) {
		const {
			item,
			form,
			evt: {
				target: { checked },
			},
		} = props;

		if (checked && !_.find(this.selected[this.tableFilter.column.title], selectedItem => item === selectedItem)) {
			this.selected[this.tableFilter.column.title].push(
				item === translate('YES') ? true : item === translate('NO') ? false : item
			);
		}
		if (!checked) {
			this.selected[this.tableFilter.column.title] = _.reduce(
				this.selected[this.tableFilter.column.title],
				(acc, val) => {
					if (val !== (item === translate('YES') ? true : item === translate('NO') ? false : item)) {
						acc.push(val);
					}
					return acc;
				},
				[]
			);
		}
		form.$('selectedList').set('value', this.selected[this.tableFilter.column.title]);
	}

	@action.bound async onApply() {
		this.form.validate().then(({ isValid }) => {
			if (isValid) {
				this.checkDatesOnDateChange();
				if (this.errorMessage === null) {
					if (
						(isSome(this.selected[this.tableFilter.column.title]) &&
							this.selected[this.tableFilter.column.title].length > 0) ||
						this.form.$('freeType').value
					) {
						this.tableFilter.column.filter = {
							selected: this.form.$('freeType').value ? null : this.selected[this.tableFilter.column.title],
							freeType: this.form.$('freeType').value,
							specificDate: null,
							dateRangeStart: null,
							dateRangeEnd: null,
							specificNumber: null,
							numberRangeStart: null,
							numberRangeEnd: null,
							hasErrors: this.form.$('filterErrorOrders').value,
						};
					} else if (
						this.form.$('specificDate').value ||
						(this.form.$('dateRangeStart').value && this.form.$('dateRangeEnd'))
					) {
						this.tableFilter.column.filter = {
							selected: null,
							freeType: null,
							specificDate:
								this.form.$('specificDate').value === ''
									? null
									: moment(this.form.$('specificDate').value, this.format)
											.endOf('day')
											.toISOString(true),
							dateRangeStart:
								this.form.$('dateRangeStart').value === ''
									? null
									: moment(this.form.$('dateRangeStart').value, this.format)
											.startOf('day')
											.toISOString(true),
							dateRangeEnd:
								this.form.$('dateRangeEnd').value === ''
									? null
									: moment(this.form.$('dateRangeEnd').value, this.format)
											.endOf('day')
											.toISOString(true),
							specificNumber: null,
							numberRangeStart: null,
							numberRangeEnd: null,
						};
					} else if (
						this.form.$('specificNumber').value ||
						this.form.$('numberRangeStart').value ||
						this.form.$('numberRangeEnd').value ||
						this.form.$('filterErrorOrders').value
					) {
						if (
							parseFloat(this.form.$('numberRangeStart').value) > parseFloat(this.form.$('numberRangeEnd').value) ||
							parseFloat(this.form.$('numberRangeStart').value) === parseFloat(this.form.$('numberRangeEnd').value)
						) {
							return this.props.viewStore.rootStore.notificationStore.error('FILTER.INVALIDNUMERICRANGE');
						}
						this.tableFilter.column.filter = {
							selected: null,
							freeType: null,
							specificDate: null,
							dateRangeStart: null,
							dateRangeEnd: null,
							specificNumber: this.form.$('specificNumber').value,
							numberRangeStart: this.form.$('numberRangeStart').value,
							numberRangeEnd: this.form.$('numberRangeEnd').value,
							hasErrors: this.form.$('filterErrorOrders').value,
						};
					}
					runInAction(() => {
						// Update main columns filtering
						_.forEach(this.tableFilter.columns, (column, idx, col) => {
							if (column.key === this.tableFilter.column.key && this.tableFilter.column.filter) {
								col[idx].filter = this.tableFilter.column.filter;
							}
						});
						this.tableFilter.visible = false;
						this.props.viewStore.rootStore.routerStore.routerState.queryParams.page = 1;
						this.tableFilter.update();
					});
				}
			}
		});
	}

	@action.bound checkDatesOnDateChange = () => {
		if (moment(this.form.$('dateRangeStart').value) > moment(this.form.$('dateRangeEnd').value)) {
			this.errorMessage = 'FILTER.INVALIDSTARTDATE';
		} else {
			this.errorMessage = null;
		}
	};

	@action.bound async onRemove() {
		this.props.viewStore.rootStore.routerStore.routerState.queryParams.page = 1;
		await this.tableFilter.remove();
	}

	@action.bound async onCheck(event, field) {
		field.value = event.currentTarget.checked;
	}

	@action.bound async onSelectAll(event) {
		this.isSelectAll = event.target.checked;
		this.selected[this.tableFilter.column.title] = [];
		if (this.isSelectAll) {
			this.form.$('searchList').value.forEach(item => {
				this.selected[this.tableFilter.column.title].push(
					item === translate('YES') ? true : item === translate('NO') ? false : item
				);
			});
		}
		this.form.$('selectedList').set('value', this.selected[this.tableFilter.column.title]);
	}

	@action.bound
	onTableFilterScroll = async () => {
		const { scrollTop, scrollHeight, offsetHeight } = this.scrollContainerRef.current;
		const { column, services } = this.tableFilter;
		if (scrollTop > 0 && scrollTop + offsetHeight + 1 >= scrollHeight && !column.isAllDataFetched) {
			column.page++;
			let seller = localStorageHandler.get('selectedSeller');
			let newData = [];

			if (column.getDistinctValues && isSome(column.service)) {
				const serviceIdx = this.getServiceIndex(services, column);
				if (serviceIdx !== -1) {
					newData = (await services[serviceIdx].getDistinctValues({
						fieldName: column.key,
						pageNumber: column.page,
						search: '',
					})).data;
				}
			} else {
				newData = await this.tableFilter.find('', seller != null ? seller.value : null);
			}

			if (!newData) return;

			this.form.$('searchList').set('value', [...this.form.$('searchList').value, ...newData]);
		}
	};

	render() {
		if (!this.tableFilter.visible) return null;
		const { top, left, startLeftValue, bottomCoordinate, startBottomValue } = this.tableFilter;
		const Component = this.tableFilter.column.filterType;

		return (
			<Component
				position={{
					top: top,
					left: left,
					tableWrap: this.tableFilter.tableWrap.clientWidth / 2,
					startLeftValue: startLeftValue,
					bottomCoordinate: bottomCoordinate,
					startBottomValue: startBottomValue,
				}}
				onClose={this.onClose}
				onClear={this.onClear}
				onSelect={this.onSelect}
				onApply={this.onApply}
				onRemove={this.onRemove}
				onSelectAll={this.onSelectAll}
				onCheck={this.onCheck}
				errorMessage={this.errorMessage}
				checkDatesOnDateChange={this.checkDatesOnDateChange}
				form={this.form}
				title={this.tableFilter.column.title}
				loading={this.loading}
				warningModal={this.warningModal}
				columnFilter={this.tableFilter.column.filter}
				rootStore={this.props.viewStore.rootStore}
				format={this.format}
				focus={this.focusContainsField}
				isFoListFilter={this.isFoListFilter}
				isSelectAll={this.isSelectAll}
				onTableFilterScroll={this.onTableFilterScroll}
				scrollContainerRef={this.scrollContainerRef}
			/>
		);
	}
}

export default observer(TableFilter);



// WEBPACK FOOTER //
// ./src/core/components/table/TableFilter.jsx